import { createSelector, createFeatureSelector } from '@ngrx/store';

import { HealthState } from './../../models/health.model';

export const getHealthState = createFeatureSelector<HealthState>('health');

export const getSomaticCellCountAttentions = createSelector(
  getHealthState,
  (state: HealthState) => state?.somaticCellCountCows,
);

export const getHealthSummary = createSelector(
  getHealthState,
  (state: HealthState) => state?.healthSummary,
);

export const getHealthYearSummary = createSelector(
  getHealthState,
  (state: HealthState) => state?.healthYearSummary,
);
